export const COMP_NAME = 'Main';
export const SITE_NAME = 'obelisk-video-editor';
/**
 * Render timeout in seconds.
 * The Obelisk backend Cloud Run service has a 600s (10 min) timeout.
 * This value is sent as a hint but the backend enforces its own limit.
 */
export const TIMEOUT_IN_SECONDS = 600;
/**
 * Memory and disk sizes are backend-managed (Cloud Run service config).
 * These constants are kept for reference / Remotion Studio local rendering only.
 */
export const MEM_SIZE_IN_MB = 3009;
export const DISK_SIZE_IN_MB = 10240;
